// Additional Notes — renders the part's DataGate additionalInfo into the product
// page. Role-gated to Branch / Head Office via the `showAdditionalInfo` feature
// flag (defence-in-depth alongside the server-side `ViewProductNotes` feature).
//
// Config (read from the TARGET element, not the script tag):
//   #parts-additional-info  OR  [data-parts-additional-info]  — the container
//   data-sku-selector="#product-sku"  (optional; overrides the SKU source)
//
// SKU source (first hit wins): the container's data-sku, then data-sku-selector /
// #product-sku, then any [data-sku] on the page.

import { getTopDocument } from '../shared/dom.js';
import { apiJson } from '../shared/api.js';
import { loadFeatures } from '../shared/identity.js';

function findContainer() {
  var doc = getTopDocument();
  return doc.getElementById('parts-additional-info') || doc.querySelector('[data-parts-additional-info]');
}

function getSku(container) {
  var doc = getTopDocument();
  // 1) explicit on the container
  var direct = container && (container.getAttribute('data-sku') || '');
  if (direct && direct.trim()) return direct.trim();
  // 2) configured selector, else #product-sku
  var selector = (container && container.getAttribute('data-sku-selector')) || '#product-sku';
  var el = doc.querySelector(selector);
  if (el) {
    var sku = el.getAttribute('data-sku') || (el.value && el.value.trim()) || el.getAttribute('value');
    if (sku && sku.trim()) return sku.trim();
  }
  // 3) any [data-sku] on the page
  var anySku = doc.querySelector('[data-sku]');
  if (anySku) {
    var s = anySku.getAttribute('data-sku');
    if (s && s.trim()) return s.trim();
  }
  return '';
}

function render(container, text) {
  container.innerHTML = ''
    + '<div class="pfai-wrap">'
    + '<div class="pfai-head">'
    + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>'
    + '<span class="pfai-title">Additional Notes</span>'
    + '</div>'
    + '<p class="pfai-body"></p>'
    + '</div>';
  // textContent (not interpolation) — DataGate note is untrusted free text.
  container.querySelector('.pfai-body').textContent = text;
}

function renderEmpty(container) {
  container.innerHTML = '<div class="pfai-empty">No additional info found for this part.</div>';
}

export function init() {
  var container = findContainer();
  if (!container) return; // not on a page with this widget

  var sku = getSku(container);
  if (!sku) {
    console.warn('PartsAdditionalInfo: No SKU found. Add data-sku on the container, an #product-sku input, or set data-sku-selector.');
    return;
  }

  // Role gate: hide entirely unless the role is permitted (server default:
  // Branch / Head Office). Suppress only on an EXPLICIT false so a features
  // outage fails open.
  loadFeatures().then(function (features) {
    if (features && features.showAdditionalInfo === false) return;
    apiJson('/api/parts/' + encodeURIComponent(sku), null, null).then(function (data) {
      var note = (data && typeof data.additionalInfo === 'string') ? data.additionalInfo.trim() : '';
      if (!note) { renderEmpty(container); return; }
      render(container, note);
    });
  });
}

export var id = 'additional-info';
